export default __webpack_public_path__ + "static/media/offer.644ba6ff.jpg";